var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0a9 9 0 10.001 18.001A9 9 0 009 0zm0 2.7a2.7 2.7 0 110 5.4 2.7 2.7 0 010-5.4zm5.237 10.05c-1.23 1.604-3.174 2.55-5.238 2.55-2.065 0-4.008-.946-5.239-2.55a.877.877 0 01-.065-.902l.196-.397c.46-.946 1.445-1.55 2.526-1.551h5.164c1.066.001 2.038.59 2.507 1.515l.214.424a.878.878 0 01-.065.911z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}

export default SvgUserWhite;